<template>
  <div class="ele-body">
    <el-card shadow="never">
      <div class="home-toolbar">
        <span class="home-title">核心数据</span>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-refresh"
          class="ele-btn-icon"
          :loading="loading"
          @click="loadAll">
          刷新
        </el-button>
      </div>

      <div class="section-label">商户余额</div>
      <el-row :gutter="15" class="stat-row">
        <el-col :lg="6" :md="12" :sm="12" :xs="24">
          <div class="stat-card theme-orange">
            <div class="stat-label">{{ $t('home.totalbalance') }}</div>
            <div class="stat-value">￥{{ formatAmount(balance.sum_balance) }}</div>
          </div>
        </el-col>
        <el-col :lg="6" :md="12" :sm="12" :xs="24">
          <div class="stat-card theme-green">
            <div class="stat-label">{{ $t('home.availablebalance') }}</div>
            <div class="stat-value">￥{{ formatAmount(balance.balance) }}</div>
          </div>
        </el-col>
        <el-col :lg="6" :md="12" :sm="12" :xs="24">
          <div class="stat-card theme-blue">
            <div class="stat-label">{{ $t('home.freezebalance') }}</div>
            <div class="stat-value">￥{{ formatAmount(balance.blockedbalance) }}</div>
          </div>
        </el-col>
        <el-col :lg="6" :md="12" :sm="12" :xs="24">
          <div class="stat-card theme-red">
            <div class="stat-label">{{ $t('home.unsettledamount') }}</div>
            <div class="stat-value">￥{{ formatAmount(balance.no_balance) }}</div>
          </div>
        </el-col>
      </el-row>

      <div class="section-label">今日代收</div>
      <el-row :gutter="15" class="stat-row">
        <el-col :lg="6" :md="12" :sm="12" :xs="24">
          <div class="stat-card">
            <div class="stat-label">总笔数</div>
            <div class="stat-value">{{ inStats.total_count }}</div>
          </div>
        </el-col>
        <el-col :lg="6" :md="12" :sm="12" :xs="24">
          <div class="stat-card">
            <div class="stat-label">成功笔数</div>
            <div class="stat-value">{{ inStats.success_count }}</div>
          </div>
        </el-col>
        <el-col :lg="6" :md="12" :sm="12" :xs="24">
          <div class="stat-card">
            <div class="stat-label">成功金额</div>
            <div class="stat-value">￥{{ formatAmount(inStats.success_amount) }}</div>
          </div>
        </el-col>
        <el-col :lg="6" :md="12" :sm="12" :xs="24">
          <div class="stat-card">
            <div class="stat-label">成功率</div>
            <div class="stat-value">{{ inStats.success_rate }}</div>
          </div>
        </el-col>
      </el-row>

      <div class="section-label">今日代付</div>
      <el-row :gutter="15" class="stat-row">
        <el-col :lg="6" :md="12" :sm="12" :xs="24">
          <div class="stat-card">
            <div class="stat-label">总笔数</div>
            <div class="stat-value">{{ outStats.total_count }}</div>
          </div>
        </el-col>
        <el-col :lg="6" :md="12" :sm="12" :xs="24">
          <div class="stat-card">
            <div class="stat-label">成功笔数</div>
            <div class="stat-value">{{ outStats.success_count }}</div>
          </div>
        </el-col>
        <el-col :lg="6" :md="12" :sm="12" :xs="24">
          <div class="stat-card">
            <div class="stat-label">成功金额</div>
            <div class="stat-value">￥{{ formatAmount(outStats.success_amount) }}</div>
          </div>
        </el-col>
        <el-col :lg="6" :md="12" :sm="12" :xs="24">
          <div class="stat-card">
            <div class="stat-label">成功率</div>
            <div class="stat-value">{{ outStats.success_rate }}</div>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
const EMPTY_BALANCE = {
  balance: '0.00',
  sj_balance: '0.00',
  blockedbalance: '0.00',
  no_balance: '0.00',
  sum_balance: '0.00',
  yesterday_balance: '0.00'
};

const EMPTY_ORDER_STATS = {
  total_count: 0,
  success_count: 0,
  fail_count: 0,
  total_amount: '0.00',
  success_amount: '0.00',
  fail_amount: '0.00',
  success_rate: '0%'
};

export default {
  name: 'FrontpageWorkplace',
  data() {
    return {
      loading: false,
      balance: { ...EMPTY_BALANCE },
      inStats: { ...EMPTY_ORDER_STATS },
      outStats: { ...EMPTY_ORDER_STATS }
    };
  },
  mounted() {
    this.loadAll();
  },
  methods: {
    formatAmount(amount) {
      if (amount === null || amount === undefined || amount === '') {
        return '0.00';
      }
      const num = parseFloat(amount);
      if (Number.isNaN(num)) {
        return '0.00';
      }
      return num.toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    loadAll() {
      this.loading = true;
      Promise.all([this.loadBalance(), this.loadInStats(), this.loadOutStats()])
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    loadBalance() {
      return this.$http
        .get('/user/getBalanceCount', { params: { asset_type: 'fiat' } })
        .then((res) => {
          if (res.data.code === 0) {
            this.balance = Object.assign({}, EMPTY_BALANCE, res.data.data || {});
            return;
          }
          this.$message.error(res.data.msg || '余额统计失败');
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
    loadInStats() {
      return this.$http
        .post('/Inorder/getInorderCount', {})
        .then((res) => {
          if (res.data.code === 0) {
            this.inStats = Object.assign({}, EMPTY_ORDER_STATS, res.data.data || {});
            return;
          }
          this.$message.error(res.data.msg || '代收统计失败');
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
    loadOutStats() {
      return this.$http
        .post('/Outorder/getInorderCount', {})
        .then((res) => {
          if (res.data.code === 0) {
            this.outStats = Object.assign({}, EMPTY_ORDER_STATS, res.data.data || {});
            return;
          }
          this.$message.error(res.data.msg || '代付统计失败');
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    }
  }
};
</script>

<style scoped>
.home-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.home-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.section-label {
  margin: 8px 0 12px;
  font-size: 14px;
  font-weight: 600;
  color: #606266;
}

.stat-row {
  margin-bottom: 8px;
}

.stat-card {
  margin-bottom: 15px;
  padding: 18px 16px;
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  border-top: 3px solid #dcdfe6;
}

.stat-label {
  margin-bottom: 10px;
  font-size: 13px;
  color: #909399;
}

.stat-value {
  font-size: 22px;
  font-weight: 700;
  color: #303133;
  line-height: 1.2;
  word-break: break-all;
}

.theme-orange {
  border-top-color: #e6a23c;
}

.theme-green {
  border-top-color: #67c23a;
}

.theme-blue {
  border-top-color: #409eff;
}

.theme-red {
  border-top-color: #f56c6c;
}
</style>
